import React, { useEffect } from 'react';
import { useSelector } from '@tmapy/redux';
import { LAYER_TYPE, LAYER_IDS, } from '@tmapy/config';
import { useOLMap } from '../MapContext';
import { actionSetLayerFeatures, actionSetLayerMapboxStyle, actionSetMapboxFeatureState, } from '../../actions';
import { featureToGeoJSONObject } from '../../utils/featureToGeoJSONObject';
import { getMergedMapboxStyles } from '../../utils/getMergedMapboxStyles';
export const InteractionHighlightMapbox = React.memo(({ dispatch, layerFilter, geometryTypeFilter, highlightedFeaturesCount }) => {
    const map = useOLMap();
    const layers = useSelector((state) => state.mapCore.layers);
    useEffect(() => {
        if (!dispatch)
            return;
        const handlePointerMove = (event) => {
            if (event.dragging) {
                return;
            }
            requestAnimationFrame(() => {
                const highlightedFeatures = [];
                let layerConfig;
                const currentFeature = map.forEachFeatureAtPixel(event.pixel, (feature, layer) => {
                    const hackFeature = feature;
                    const layerId = hackFeature.get('layer_id') ?? layer?.get('id');
                    //nepokracuj, pokud se jedna o panoramu, nebo highlight vrstvu
                    if (layerId === LAYER_IDS.PANORAMA || layerId === LAYER_IDS.HIGHLIGHT) {
                        return;
                    }
                    const featureId = (hackFeature.getId() ||
                        hackFeature.get('id') ||
                        hackFeature.ol_uid);
                    // nepokracuj, pokud se predavaji data z TWC tabulky a id nesouhlasi s id feature
                    // resi zobrazeni fetaure dle id ve shluku prvku nad sebou
                    if (event.data?.id && featureId !== event.data.id) {
                        return;
                    }
                    // pro akci kliknuti a zobrazeni detailu - routa
                    if (hackFeature.properties_) {
                        hackFeature.properties_._originLayerId = layerId;
                    }
                    layerConfig = layers.find((layer) => (layer.type === LAYER_TYPE.VECTOR || layer.type === LAYER_TYPE.TILE_VECTOR) &&
                        layer.id === layerId &&
                        layer.id !== LAYER_IDS.HIGHLIGHT);
                    let isFiltered = true;
                    if (geometryTypeFilter) {
                        const geomType = hackFeature.getGeometry()?.getType();
                        isFiltered = !!geomType && geometryTypeFilter.includes(geomType);
                    }
                    if (layerId && featureId && isFiltered) {
                        highlightedFeatures.push({
                            featureId,
                            layerId,
                            feature: featureToGeoJSONObject(hackFeature),
                        });
                        // mapbox section
                        if (layer.get('mapbox-featurestate')) {
                            // feature.id is needet because of mapbox-style - apply.js
                            if (!hackFeature.id) {
                                hackFeature.id = featureId;
                            }
                            return { layer, feature: hackFeature };
                        }
                    }
                }, {
                    layerFilter,
                });
                // mix and set mapboxStyle
                if (layerConfig && currentFeature) {
                    const mergedMapboxStyles = getMergedMapboxStyles(LAYER_IDS.HIGHLIGHT, layerConfig, currentFeature);
                    if (mergedMapboxStyles && currentFeature) {
                        dispatch(actionSetLayerMapboxStyle(LAYER_IDS.HIGHLIGHT, mergedMapboxStyles));
                        dispatch(actionSetLayerFeatures(LAYER_IDS.HIGHLIGHT, [
                            featureToGeoJSONObject(currentFeature.feature),
                        ]));
                        dispatch(actionSetMapboxFeatureState({
                            layerId: LAYER_IDS.HIGHLIGHT,
                            featureId: currentFeature.feature.getId() ?? currentFeature.feature.get('id'),
                            state: { hover: true },
                        }));
                    }
                }
                else {
                    if (!currentFeature || !highlightedFeatures.length) {
                        dispatch(actionSetLayerFeatures(LAYER_IDS.HIGHLIGHT, []));
                    }
                }
            });
        };
        map.on('pointermove', handlePointerMove);
        return () => {
            map.un('pointermove', handlePointerMove);
        };
    }, [map, layerFilter, dispatch, highlightedFeaturesCount, geometryTypeFilter]);
    return null;
});
//# sourceMappingURL=InteractionHighlightMapbox.js.map